import dayjs from 'dayjs';

/** Formats a datetime string using dayjs. */
export const formatDateTime = (dateTime) => {
  return dayjs(dateTime).format('YYYY-MM-DD hh:mm a');
};

/** Formats a number to two decimal places. */
export const formatDecimal = (number) => {
  return Number(number).toFixed(2);
}

/** Formats mileage with thousands separators. */
export const formatMileage = (mileage) => {
  if (mileage === null || mileage === undefined || mileage === '') {
    return '';
  }

  const numericMileage = Number(mileage);

  return Number.isNaN(numericMileage)
    ? mileage
    : numericMileage.toLocaleString('en-US');
};